import React, { useEffect, useMemo } from 'react'
import { Grid, Row, Col, Button, Stack, Text } from 'rsuite'
import { PAYMENT_METHODS } from '../constants';
import { setSelectedPaymentMethod } from '../../../store/slices/payment/paymentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedPaymentMethod } from '../../../store/slices/payment/paymentSelectors';
import { selectConfigEnableACH, selectConfigEnableCC, selectConfigEnableCheck } from '../../../store/slices/config/configSelectors';

const PaymentMethodSelector = () => {
    const dispatch = useDispatch();
    const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

    const creditCardEnabled = useSelector(selectConfigEnableCC);
    const achDirectDebitEnabled = useSelector(selectConfigEnableACH);
    // const achBankTransferEnabled = useSelector(selectConfigEnablePushACH);
    const checkEnabled = useSelector(selectConfigEnableCheck);

    const multipleEnabled = useMemo(() => {
        const enabled =  [creditCardEnabled, achDirectDebitEnabled, checkEnabled].reduce((prev, element) => {
            if(element){
                prev.push(element)
            }
            return prev;
        }, []);
        return enabled.length > 1;
    }, [creditCardEnabled, achDirectDebitEnabled, checkEnabled])

    useEffect(() => {
        const getFirstEnabledPaymentMethod = () => {
            if (achDirectDebitEnabled) return PAYMENT_METHODS.ACH_DIRECT_DEBIT;
            // if (achBankTransferEnabled) return PAYMENT_METHODS.ACH_BANK_TRANSFER;
            if (creditCardEnabled) return PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD;
            if (checkEnabled) return PAYMENT_METHODS.CHECK;
            return '';
        };
        const paymentMethod = getFirstEnabledPaymentMethod();
        dispatch(setSelectedPaymentMethod(paymentMethod));
    }, [creditCardEnabled, achDirectDebitEnabled, checkEnabled, dispatch]);

    const handleSetSelectedPaymentMethod = (paymentMethod) => {
        dispatch(setSelectedPaymentMethod(paymentMethod));
    }
    return (
        <Grid fluid>
            <Row className='mb-8'>
                <Col xs={24}>
                    <Text className='text-small text-bold'>Payment Method</Text>
                </Col>
            </Row>
            {multipleEnabled && <Row>
                {
                    achDirectDebitEnabled && (
                        <Col xs={24} md={12} className='mb-8'>
                            <Button onClick={() => { handleSetSelectedPaymentMethod(PAYMENT_METHODS.ACH_DIRECT_DEBIT); }}
                                className={`payment-type-button ${selectedPaymentMethod === PAYMENT_METHODS.ACH_DIRECT_DEBIT ? 'payment-type-button-active' : ''}`}>
                                <Stack direction='column' alignItems='flex-start' style={{ width: '100%' }}>
                                    <img src='/assets/bank-building-ACH-direct-debit.svg' alt='ACH Icon' height='12px' />
                                    <Text className='text-small'>ACH Direct Debit</Text>
                                </Stack>
                            </Button>
                        </Col>
                    )
                }
                {/* No jurisdictions currently uase achBankTransfer. This needs to completed and teste dif it is ever added. */}
                {/* {
                    achBankTransferEnabled && (
                        <Col xs={24} md={12} className='mb-8'>
                            <Button onClick={() => { handleSetSelectedPaymentMethod(PAYMENT_METHODS.ACH_BANK_TRANSFER); }}
                                className={`payment-type-button ${selectedPaymentMethod === PAYMENT_METHODS.ACH_BANK_TRANSFER ? 'payment-type-button-active' : ''}`}>
                                <Stack direction='column' alignItems='flex-start' style={{ width: '100%' }}>
                                    <img src='\assets\bank-building-ACH-bank-transfer.svg' alt='ACH Icon' height='12px' />
                                    <div>ACH Bank Transfer</div>
                                </Stack>
                            </Button>
                        </Col>
                    )
                } */}
                {
                    creditCardEnabled && (
                        <Col xs={24} md={12} className='mb-8'>
                            <Button onClick={() => { handleSetSelectedPaymentMethod(PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD); }}
                                className={`payment-type-button ${selectedPaymentMethod === PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD ? 'payment-type-button-active' : ''}`}>
                                <Stack direction='column' alignItems='flex-start' style={{ width: '100%' }}>
                                    <img src='\assets\credit-card-icon.svg' alt='ACH Icon' height='15px' />
                                    <Text className='text-small'>Credit or Debit Card</Text>
                                </Stack>
                            </Button>
                        </Col>
                    )
                }
                {
                    checkEnabled && (
                        <Col xs={24} md={12} className='mb-8'>
                            <Button onClick={() => { handleSetSelectedPaymentMethod(PAYMENT_METHODS.CHECK); }}
                                className={`payment-type-button ${selectedPaymentMethod === PAYMENT_METHODS.CHECK ? 'payment-type-button-active' : ''}`}>
                                <Stack direction='column' alignItems='flex-start' style={{ width: '100%' }}>
                                    <img src='\assets\cheque-sign-icon.svg' alt='ACH Icon' height='12px' />
                                    <Text className='text-small'>Check</Text>
                                </Stack>
                            </Button>
                        </Col>
                    )
                }
            </Row>}
        </Grid>
    )
}

export default PaymentMethodSelector
